<template>
  <span class="btn-panorama">
    <label class="btn-panorama__checkbox">
      <input
        type="checkbox"
        class="checkbox"
        :class="[{ view_only: item.view_only === 1 || status.f_auto_conv === 1 || status.send_type === 3 }]"
        value="1"
        v-model="status.panorama_flag"
        :disabled="status.send_disabled || item.view_only === 1 || status.f_auto_conv === 1 || status.send_type === 3"
        @change="onClickPanoramaStatus(id, item.shop_id, status.portal_site_cd, status.panorama_flag, status)"
      />
      パノラマ
    </label>
    <i-button
      size="small"
      class="btn-convert"
      :class="[
        status.state,
        { error: status.error, view_only: item.view_only === 1 || status.f_auto_conv === 1 || status.send_type === 3 },
      ]"
      style="padding-right: 74px;"
      @click="onClickConvertStatus(id, item.shop_id, status.portal_site_cd, status.state, item.view_only, status)"
      :loading="status.loading"
      :disabled="status.send_disabled"
    >
      {{ status.portal_site_name }}
    </i-button>
  </span>
</template>

<script>
import { Button } from 'view-design'
export default {
  components: {
    'i-button': Button,
  },
  props: {
    id: {
      type: Number,
      default: null,
      required: true,
    },
    item: {
      type: Object,
      default: () => {},
      required: true,
    },
    status: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  methods: {
    // パノラマボタン クリック処理
    onClickPanoramaStatus(id, shopId, site, panoramaFlag, status) {
      this.$emit('panorama', id, shopId, site, panoramaFlag, status)
    },
    // コンバートボタン クリック処理
    onClickConvertStatus(id, shopId, siteCd, state, viewOnly, status) {
      this.$emit('convert', id, shopId, siteCd, state, viewOnly, status)
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-panorama {
  position: relative;
  cursor: pointer;

  &__checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -4px;
    right: 8px;
    z-index: 98;
    margin-bottom: 0;
    padding: 0 4px;
    border: 1px solid #cfcfcf;
    border-radius: 4px;
    font-size: 0.5em;
    color: #2d8cf0;
    background-color: #fff;

    .checkbox {
      margin-right: 2px;
      &.view_only {
        cursor: not-allowed;
      }
    }
  }
}
</style>
